<template lang="pug">
  .preloader(v-show="$store.getters['preloader/isShown']")
    .overlay
    .rotor
      .rotor-item(v-for="i in 12")
</template>

<script>
export default {
  name: 'BasePreloader',
};
</script>

<style scoped lang="scss">
  @use "sass:math";

  .preloader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999999;
    display: flex;
    justify-content: center;
    align-items: center;

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0, .5);
    }

    .rotor {

    }

    .rotor-item {
      width: 10px; height: 10px; margin: 15px;
      display:inline-block;
      border-radius: 50%;

      @for $i from 0 through 12 {
        &:nth-child(#{$i+1}) {
          //animation: pulse 2s #{$i/6}s linear infinite;
          position:absolute;
          margin-top: #{50*math.sin($i * 30deg)}px;
          margin-left: #{50*math.cos($i * 30deg)}px;
        }
      }

      @for $i from 0 through 6 {
        &:nth-child(#{$i+1}) {
          animation: pulse 0.5s #{$i/12}s linear infinite;
        }
        &:nth-child(#{$i+7}) {
          animation: pulse 0.5s #{$i/12}s linear infinite;
        }
      }
    }
  }

  @keyframes pulse {
    100% {
      box-shadow: 0 0 0 rgba(0,0,0,0),
      //0 0 0 rgba(255,255,255,0),
      inset 5px 5px 4px rgba(255, 255, 255, 0),
      inset -3px -3px 4px  rgba(0,0,0,0);
    }
    //25%{
    //  box-shadow: 10px 10px 20px rgba(0,0,0,0.2),
    //  -5px -5px 10px rgba(255,255,255,0.2),
    //  inset 5px 5px 4px rgba(255, 255, 255, 0.3),
    //  inset -3px -3px 4px  rgba(0,0,0,0.1);
    //}
    0% {
      box-shadow: 10px 10px 20px rgba(0,0,0,0),
      //-5px -5px 10px rgba(255,255,255,0.5),
      inset 5px 5px 4px rgba(255, 255, 255, 0.3),
      inset -3px -3px 4px  rgba(0,0,0,0.1);
    }
    //75%{
    //  box-shadow: 10px 10px 20px rgba(0,0,0,0.2),
    //  -5px -5px 10px rgba(255,255,255,0.2),
    //  inset 5px 5px 4px rgba(255, 255, 255, 0.3),
    //  inset -3px -3px 4px  rgba(0,0,0,0.1);
    //}
    //100% {
    //  box-shadow: 0 0 0 rgba(0,0,0,0),
    //  0 0 0 rgba(255,255,255,0),
    //  inset 5px 5px 4px rgba(255, 255, 255, 0),
    //  inset -3px -3px 4px  rgba(0,0,0,0);
    //}
  }
</style>
